import { TAccountRightsFeatureList } from '@app/services/account-rights-service/response-interfaces/account-rights';

export const FEATURE_CONTACT_AND_SUPPORT: TAccountRightsFeatureList =
  'ContactAndSupport';
